import React from "react";

const SkellitonCard = () => {
  return (
    <div
      id="w-node-fcce1b21-3954-7070-54ad-f0ea51f92fae-3890e283"
      className="table-list-card"
    >
      <div className="text-5xl text-black"></div>
      <div className="property-image custom-bg _2">
        <div className="table-card-div">
          <div className="property-image-inner">
            <div className="p-image-inner-info-top">
              <div className="card-image-left-meta"></div>
              <div className="card-image-left-meta">
                {/* {bookmarks.includes(slide.id) ? ( */}
              </div>
            </div>
          </div>
          <div
            id="w-node-fcce1b21-3954-7070-54ad-f0ea51f92fbb-3890e283"
            className="table-card-image w-inline-block"
          >
            <img
              loading="lazy"
              src={`https://img.freepik.com/free-photo/abstract-surface-textures-white-concrete-stone-wall_74190-8184.jpg`}
              alt=""
              className="table-image-oncard placeholderimg"
            />
          </div>
        </div>
      </div>
      <div
        id="w-node-fcce1b21-3954-7070-54ad-f0ea51f92fbd-3890e283"
        className="card-details w-inline-block"
      >
        <div className="flex items-center mt-4">
          <svg
            className="w-10 h-10 me-3 text-gray-200 dark-:text-gray-700"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
          </svg>
          <div>
            <div className="h-2.5 bg-gray-200 rounded-full dark-:bg-gray-700 w-32 mb-2"></div>
            <div className="w-48 h-2 bg-gray-200 rounded-full dark-:bg-gray-700"></div>
          </div>
        </div>
        <div className="card-meta-datat comapny-and-date">
          <div className="property-size property-company">
            <div className="host-dp">
              <img loading="lazy" alt="" className="host-image-on-card" />
            </div>
            <p className="host-name darkgrey"></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkellitonCard;
